export default __webpack_public_path__ + "static/media/es.d2a95059.svg";